import { render } from "./Referral.vue?vue&type=template&id=ee2a187c&scoped=true"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"

import "./Referral.vue?vue&type=style&index=0&id=ee2a187c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee2a187c"]])

export default __exports__